<template>
    <div class="is-loading">
        <header>
            <div class="grid-content grid-unstackable">
                <div class="grid-item no-flex show-on-tablet">
                    <div class="item-loading loading-background"></div>
                </div>
                <div class="grid-item">
                    <div class="item-loading search-bar loading-background"></div>
                </div>
                <div class="grid-item no-flex show-on-tablet">
                    <div class="item-loading loading-background"></div>
                </div>
                <div class="grid-item no-flex hide-on-tablet">
                    <div class="item-loading stream loading-background"></div>
                </div>
            </div>
        </header>
        <nav class="hide-on-tablet">
            <div class="logo stack-l">
                <div class="mr-re"></div>
                <div class="mr-bil"></div>
                <div class="mr-ly"></div>
            </div>
            <div class="item-loading stack-s"></div>
            <div class="item-loading stack-s"></div>
            <div class="item-loading stack-s"></div>
            <div class="nav-secondary-actions">
                <div class="item-loading stack-s"></div>
                <div class="item-loading stack-s"></div>
                <div class="item-loading stack-m"></div>
                <div class="item-loading"></div>
            </div>
        </nav>
    </div>
</template>

<script>
    export default {
        data() {
            return {
            };
        },
    };
</script>
